export default __webpack_public_path__ + "static/media/gusano recortado.07668c4d.png";